module.exports = __webpack_public_path__ + "img/aggregate-line-long.7ed32857.svg";